export interface ArticleComment {
  id: string;
  userName: string;
  userAvatar: string;
  content: string;
  likes: number;
  publishDate: string;
  replies?: ArticleComment[];
}

export interface ArticleData {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  readTime: string;
  viewCount: number;
  mainImage: string;
  tags: string[];
  content: string[];
  relatedImages: Array<{
    url: string;
    caption: string;
  }>;
  comments: ArticleComment[];
  hotScore: number;
}

function makeAvatar(_seq: string): string {
  return 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20character%20avatar%20portrait%20friendly%20expression%20warm%20pastel%20colors%20simple%20flat%20illustration%20minimal%20background&width=100&height=100&seq=generic-avatar&orientation=squarish';
}

export const articleData: Record<string, ArticleData> = {
  'article-1': {
    id: 'article-1',
    title: '某顶流艺人深夜密会神秘女子，酒店共度8小时',
    subtitle: '神秘女子酒店共度8小时，疑似新恋情曝光',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    author: '吃瓜前线',
    publishDate: '2026-07-06',
    readTime: '5分钟',
    viewCount: 1285630,
    mainImage: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20luxury%20hotel%20entrance%20at%20night%20with%20warm%20golden%20lighting%2C%20a%20luxury%20car%20parked%20outside%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20mysterious%20and%20elegant%20scene%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style%20with%20warm%20tones%20and%20dark%20shadows&width=1200&height=675&seq=article-1-main&orientation=landscape',
    tags: ['顶流塌房', '恋情曝光', '独家爆料'],
    content: [
      '据知情人士独家爆料，某当红顶流男艺人（以下简称Z某）近日被拍到与一位神秘女子在某五星级酒店密会长达8小时。两人举止亲密，疑似新恋情浮出水面。',
      '根据狗仔拍摄的画面显示，当晚约10点左右，Z某独自驾车抵达酒店地下停车场。他身着黑色休闲装，头戴棒球帽和口罩，显然是有意掩人耳目。大约15分钟后，一位身着白色连衣裙的长发女子出现在酒店大堂，径直走向电梯。',
      '值得注意的是，该女子进入电梯后直接按下了与Z某同一楼层的按钮。随后有酒店工作人员向本网证实，当晚该楼层确实有Z某以助理名义登记的房间。',
      '直到次日凌晨6时许，Z某才独自驾车离开酒店。从时间线来看，两人共处时间超过8小时。更令人浮想联翩的是，Z某离开时神情明显放松，嘴角似乎带着笑意。',
      'Z某作为当下最炙手可热的男艺人之一，近年来事业发展如日中天，接连出演了多部热播剧和电影。其感情状况一直备受粉丝关注。此前他曾公开表示"目前单身，专注事业"，此次密会事件无疑会对他的公众形象造成不小的冲击。',
      '截至目前，Z某的工作室尚未就此事发表任何官方声明。其社交媒体账号也处于静默状态。而其粉丝群体则呈现两极分化态势——一部分粉丝表示"如果是真爱就祝福"，另一部分则坚决否认，称"这一定是P图造谣"。',
      '业内人士分析认为，若此事件属实，Z某不仅将面临人设崩塌的风险，其正在洽谈的几个重要商业代言也可能受到影响。一位不愿透露姓名的娱乐营销专家表示："品牌方对代言人形象要求极高，恋爱本身不是问题，但隐瞒和欺骗才是最大的减分项。"',
      '本网将持续关注此事进展。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Celebrity%20entering%20a%20luxury%20hotel%20at%20night%2C%20wearing%20black%20cap%20and%20mask%2C%20surrounded%20by%20bodyguards%2C%20warm%20golden%20hotel%20lobby%20lights%2C%20paparazzi%20style%20photography%2C%20soft%20ambient%20glow&width=800&height=533&seq=article-1-rel-01&orientation=landscape',
        caption: 'Z某被拍到深夜步入酒店大堂'
      },
      {
        url: 'https://readdy.ai/api/search-image?query=Mysterious%20woman%20in%20white%20dress%20walking%20through%20luxury%20hotel%20lobby%2C%20back%20view%2C%20elegant%20and%20mysterious%2C%20warm%20chandelier%20lighting%2C%20cinematic%20photography&width=800&height=533&seq=article-1-rel-02&orientation=landscape',
        caption: '神秘女子身着白裙出现在酒店大堂'
      }
    ],
    comments: [
      { id: 'cmt-1', userName: '吃瓜不嫌事大', userAvatar: makeAvatar('avatar-01'), content: '我就说嘛，顶流哪有不谈恋爱的？只是藏得好不好而已。这下实锤了吧！', likes: 12563, publishDate: '2026-07-06' },
      { id: 'cmt-2', userName: '娱乐圈观察家', userAvatar: makeAvatar('avatar-02'), content: '据我所知，这位神秘女子的身份也不简单，据说是某知名导演的女儿。等着看吧，很快就有后续了。', likes: 9876, publishDate: '2026-07-06' },
      { id: 'cmt-3', userName: '路人甲乙丙', userAvatar: makeAvatar('avatar-03'), content: '8个小时...我不好说了，懂的都懂。希望工作室赶紧出来回应吧。', likes: 7654, publishDate: '2026-07-06' },
      { id: 'cmt-4', userName: '铁粉一枚', userAvatar: makeAvatar('avatar-04'), content: '不管怎样我都会支持他的！艺人也有谈恋爱的权利，大家不要太苛责了。', likes: 5432, publishDate: '2026-07-06' },
      { id: 'cmt-5', userName: '理智吃瓜群众', userAvatar: makeAvatar('avatar-05'), content: '等官方回应吧，现在都是狗仔的一面之词。万一是恶意剪辑呢？瓜要慢慢吃。', likes: 3210, publishDate: '2026-07-06' }
    ],
    hotScore: 98532
  },

  'article-2': {
    id: 'article-2',
    title: '知名网红直播翻车，假货风波持续发酵引众怒',
    subtitle: '千万粉丝网红带货翻车，假货风波持续发酵',
    category: '网红黑料',
    categorySlug: 'influencer-drama',
    author: '打假先锋',
    publishDate: '2026-07-05',
    readTime: '8分钟',
    viewCount: 987321,
    mainImage: 'https://readdy.ai/api/search-image?query=A%20beauty%20influencer%20live%20streaming%20setup%20with%20ring%20light%20and%20makeup%20products%20on%20a%20desk%2C%20warm%20studio%20lighting%2C%20dramatic%20shadows%2C%20luxury%20makeup%20products%20scattered%20around%2C%20cinematic%20photography&width=1200&height=675&seq=article-2-main&orientation=landscape',
    tags: ['假货风波', '直播翻车', '消费者维权'],
    content: [
      '拥有千万粉丝的知名美妆网红"L姐"近日遭遇职业生涯最大危机。她在直播间大力推荐的"国际大牌平替"系列产品，被多名粉丝和业内人士实锤为三无产品，这一事件在网络上引发轩然大波。',
      '事情的起因要追溯到上周的一场直播。L姐在直播间中宣称自己找到了一款"效果完全不输国际大牌"的护肤套装，并以"宠粉价"199元的价格进行限时促销。凭借其强大的带货能力，该产品在上架后不到10分钟内便售出超过5万套，销售额突破千万元。',
      '然而，产品发货后不久，问题便开始浮出水面。多位购买者在社交平台上反映，收到的产品包装粗糙、气味刺鼻，且没有任何中文标签和生产信息。更严重的是，有部分消费者在使用后出现皮肤红肿、瘙痒等过敏症状。',
      '一位自称化妆品行业从业十年的业内人士在网上发文指出，该产品的成分表完全不符合国家标准，其中含有多种已被禁用的有害物质。该帖文迅速获得大量转发，舆论开始全面发酵。',
      '面对汹涌的舆论，L姐最初选择了沉默。在压力下，她在社交平台发布了一份简短的道歉声明，称"对供应链审核不严，愿意全额退款"。但这一回应显然无法平息众怒，网友纷纷指责其"事先收钱、事后甩锅"的态度。',
      '目前，市场监督管理部门已经介入调查。而L姐的社交账号评论区已被愤怒的消费者攻陷，其多个商业合作品牌也紧急撤下了与其相关的宣传内容。这场假货风波，恐怕还远未结束。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20counterfeit%20makeup%20products%20on%20a%20white%20table%2C%20fake%20luxury%20brand%20packaging%2C%20investigative%20journalism%20style%2C%20bright%20clean%20lighting&width=800&height=533&seq=article-2-rel-01&orientation=landscape',
        caption: '消费者收到的三无产品，包装粗糙无中文标识'
      },
      {
        url: 'https://readdy.ai/api/search-image?query=Angry%20consumers%20checking%20beauty%20products%20with%20magnifying%20glass%2C%20suspicious%20expressions%2C%20worried%20atmosphere%2C%20warm%20indoor%20lighting&width=800&height=533&seq=article-2-rel-02&orientation=landscape',
        caption: '消费者在仔细检查产品成分表'
      }
    ],
    comments: [
      { id: 'cmt-6', userName: '再也不相信网红了', userAvatar: makeAvatar('avatar-06'), content: '我就是受害者之一！用了之后脸上起了红疹，去医院花了3000多才治好。强烈要求L姐赔偿！', likes: 15876, publishDate: '2026-07-05' },
      { id: 'cmt-7', userName: '美妆业内人士', userAvatar: makeAvatar('avatar-07'), content: '这个成分我看了，里面含有禁用防腐剂和激素类物质，长期使用会导致激素依赖性皮炎。太可怕了！', likes: 12345, publishDate: '2026-07-05' },
      { id: 'cmt-8', userName: '理性消费者', userAvatar: makeAvatar('avatar-08'), content: '大家以后买东西一定要看清成分和资质，不要被网红的花言巧语给骗了。便宜没好货是真理。', likes: 9876, publishDate: '2026-07-05' }
    ],
    hotScore: 87421
  },

  'card-1': {
    id: 'card-1',
    title: '某女星离婚内幕曝光，财产分割细节惊人',
    subtitle: '财产分割涉及数亿资产，双方律师团队已交锋三轮',
    category: '豪门恩怨',
    categorySlug: 'rich-drama',
    author: '婚姻观察员',
    publishDate: '2026-07-04',
    readTime: '6分钟',
    viewCount: 876543,
    mainImage: 'https://readdy.ai/api/search-image?query=Elegant%20courtroom%20interior%20with%20warm%20wooden%20furniture%2C%20legal%20documents%20on%20a%20desk%2C%20soft%20natural%20light%20streaming%20through%20windows%2C%20dramatic%20atmosphere%2C%20cinematic%20composition%2C%20warm%20amber%20and%20brown%20tones&width=1200&height=675&seq=card-1-main&orientation=landscape',
    tags: ['离婚内幕', '财产分割', '豪门恩怨'],
    content: [
      '近日，某知名女星（以下简称Y姐）与富商丈夫的离婚案持续引发公众关注。据知情人透露，双方财产分割涉及金额高达数亿元，包括多处豪宅、海外资产及股权投资，目前双方律师团队已进行三轮激烈交锋。',
      'Y姐与丈夫结婚五年，育有一女。此前两人多次在公开场合秀恩爱，被视为娱乐圈的模范夫妻。然而，今年三月起，两人社交互动骤减，引发外界猜测。直到上个月，Y姐被拍到独自搬离两人共同居住的豪宅，离婚传闻才不胫而走。',
      '据内部人士爆料，导致婚姻破裂的直接原因是丈夫长期出轨。Y姐掌握的证据包括酒店监控、转账记录以及第三者的身份信息。更令外界震惊的是，Y姐还意外发现丈夫在婚内曾多次转移夫妻共同财产至境外账户。',
      '在财产分割问题上，Y姐方面主张按照婚姻存续期间的实际贡献进行分配，并要求获得女儿的抚养权。而男方则坚称大部分资产属于其婚前财产，Y姐无权分割。双方僵持不下，案件已进入司法程序。',
      '值得一提的是，Y姐的闺蜜团近期纷纷在社交平台发声支持她，称其"勇敢、坚强"。而男方的商业伙伴则保持沉默，似乎在观望事态走向。这场离婚大战的最终结果，恐怕还要持续一段时间才能尘埃落定。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20exterior%20with%20moving%20trucks%20and%20boxes%2C%20divorce%20moving%20out%20scene%2C%20warm%20golden%20hour%20lighting%2C%20dramatic%20atmosphere&width=800&height=533&seq=card-1-rel-01&orientation=landscape',
        caption: 'Y姐被拍到从豪宅搬离'
      }
    ],
    comments: [
      { id: 'cmt-c1-1', userName: '婚姻律师', userAvatar: makeAvatar('c1-ava-01'), content: '这种情况女方胜算很大，只要婚内转移财产的 evidence 充分，法院会支持重新分割。', likes: 8765, publishDate: '2026-07-04' },
      { id: 'cmt-c1-2', userName: '路人吃瓜', userAvatar: makeAvatar('c1-ava-02'), content: '看着挺恩爱的一对，没想到背后这么狗血。娱乐圈真的没有真爱吗？', likes: 6543, publishDate: '2026-07-04' }
    ],
    hotScore: 76321
  },

  'card-2': {
    id: 'card-2',
    title: '综艺录制现场冲突，两位导师当场翻脸',
    subtitle: '录制中断三小时，节目组紧急公关',
    category: '综艺翻车',
    categorySlug: 'show-fails',
    author: '片场狗仔',
    publishDate: '2026-07-03',
    readTime: '4分钟',
    viewCount: 765432,
    mainImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20with%20dramatic%20stage%20lighting%20and%20two%20people%20in%20heated%20argument%2C%20red%20and%20blue%20spotlights%20creating%20dramatic%20tension%2C%20reality%20show%20atmosphere%2C%20cinematic%20photography%2C%20warm%20and%20cool%20contrast&width=1200&height=675&seq=card-2-main&orientation=landscape',
    tags: ['综艺冲突', '导师翻脸', '录制事故'],
    content: [
      '某热门选秀综艺近日在录制过程中突发状况。两位导师A和B因对选手晋级结果产生严重分歧，当场爆发激烈争吵，导致录制中断长达三小时。',
      '据现场工作人员透露，争执的起因是一名备受争议的选手是否应该晋级下一轮。导师A认为该选手具备独特的舞台魅力，应该给予机会；而导师B则坚持认为其基本功不达标，晋级会对其他选手不公平。',
      '争吵过程中，导师B情绪失控，摔掉了手中的评分板，并愤然离席。导师A也不甘示弱，当众指责导师B"缺乏专业素养，以个人喜好代替评审标准"。场面一度十分尴尬，现场选手和观众面面相觑。',
      '节目组紧急介入调停，但两位导师均拒绝向对方道歉。最终，在制片人的斡旋下，双方同意先完成剩余录制，争议留待后期剪辑处理。然而，这段冲突的全过程已被现场观众拍摄并上传网络，引发热议。',
      '截至目前，两位导师的经纪团队均未对此事作出回应。但据业内人士分析，该综艺的收视率可能会因此事件获得意外的关注度提升。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Angry%20person%20throwing%20microphone%20on%20stage%2C%20dramatic%20shattered%20pieces%2C%20reality%20TV%20drama%20scene%2C%20warm%20spotlight%20lighting&width=800&height=533&seq=card-2-rel-01&orientation=landscape',
        caption: '导师B愤然摔掉评分板'
      }
    ],
    comments: [
      { id: 'cmt-c2-1', userName: '综艺老粉', userAvatar: makeAvatar('c2-ava-01'), content: '这剧本太明显了，综艺没有冲突哪来的收视率？大家看看就好别当真。', likes: 9876, publishDate: '2026-07-03' },
      { id: 'cmt-c2-2', userName: '理性观众', userAvatar: makeAvatar('c2-ava-02'), content: '不管是不是剧本，这种场面确实挺刺激的。好奇后期会怎么剪。', likes: 5432, publishDate: '2026-07-03' }
    ],
    hotScore: 68932
  },

  'card-3': {
    id: 'card-3',
    title: '富豪家族争产风波，百亿遗产引发兄妹反目',
    subtitle: '三代家族企业面临分裂危机',
    category: '豪门恩怨',
    categorySlug: 'rich-drama',
    author: '财经八卦君',
    publishDate: '2026-07-02',
    readTime: '7分钟',
    viewCount: 654321,
    mainImage: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20exterior%20with%20grand%20architecture%2C%20golden%20hour%20sunset%20lighting%2C%20dramatic%20shadows%2C%20wealth%20and%20power%20symbolism%2C%20cinematic%20wide%20shot%2C%20warm%20golden%20and%20dark%20tones&width=1200&height=675&seq=card-3-main&orientation=landscape',
    tags: ['家族争产', '百亿遗产', '豪门恩怨'],
    content: [
      '某知名地产家族近日陷入争产风波。家族创始人老爷子去世后，留下的百亿遗产分配方案引发了家族内部的激烈冲突，长子与次女各执一词，三代家族企业面临分裂危机。',
      '据悉，老爷子生前并未留下明确的遗嘱，仅在家族会议上口头表示"财产由长子主要继承，女儿们也有份"。但这一模糊表态在老爷子离世后成为各方争夺的焦点。',
      '长子方面主张按照传统继承规则，由男性继承人接管家族企业，女儿们获得固定比例的现金分配。而次女则认为自己在企业经营中贡献巨大，理应获得与兄长平等的继承权。',
      '更令人关注的是，老爷子生前最疼爱的小儿子（第三子）也加入了战局。他声称老爷子生前曾多次表示要把最值钱的海外资产留给他。这一说法遭到了长子和次女的共同质疑。',
      '目前，三方已各自聘请了顶级律师团队，遗产纠纷案已正式立案。业内观察人士指出，无论最终结果如何，这场家族内斗都将对企业声誉和股价造成不利影响。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20with%20three%20people%20arguing%20across%20a%20long%20table%2C%20dramatic%20lighting%2C%20family%20business%20conflict%2C%20warm%20wood%20tones&width=800&height=533&seq=card-3-rel-01&orientation=landscape',
        caption: '三兄妹在董事会上各执一词'
      }
    ],
    comments: [
      { id: 'cmt-c3-1', userName: '法律人', userAvatar: makeAvatar('c3-ava-01'), content: '没有遗嘱的情况下，法定继承是均等分配。长子想独吞是不可能的。', likes: 7654, publishDate: '2026-07-02' },
      { id: 'cmt-c3-2', userName: '吃瓜群众', userAvatar: makeAvatar('c3-ava-02'), content: '有钱人的烦恼我也想有。百亿遗产分我百分之一就够了。', likes: 6543, publishDate: '2026-07-02' }
    ],
    hotScore: 65418
  },

  'card-4': {
    id: 'card-4',
    title: '知名导演潜规则爆料，多位女演员实名举报',
    subtitle: '剧组内部人员联合发声',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    author: '圈内人',
    publishDate: '2026-07-01',
    readTime: '6分钟',
    viewCount: 543210,
    mainImage: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20dramatic%20lighting%20with%20harsh%20shadows%2C%20mysterious%20atmosphere%2C%20behind%20the%20scenes%20movie%20production%2C%20cinematic%20photography%20with%20warm%20spotlight&width=1200&height=675&seq=card-4-main&orientation=landscape',
    tags: ['潜规则', '实名举报', '导演黑料'],
    content: [
      '某知名电影导演（以下简称D导）近日被多位女演员实名举报存在潜规则行为。举报者不仅包括新人演员，还有已在圈内小有名气的艺人。这一爆料迅速在行业内掀起轩然大波。',
      '首位公开实名举报的是演员小M。她在社交平台发布长文，详细描述了D导以"试戏"为由将她约至私人会所，并在会面期间提出不当要求的全过程。她还附上了当时的聊天记录和会所监控截图作为证据。',
      '小M的勇敢发声很快引发了连锁反应。随后，演员小N、小P等人也相继站出来，讲述了自己或身边朋友遭遇的类似经历。据她们描述，D导的行为模式十分固定：先以角色为诱饵接近目标，再以"行业规矩"为由施压，最后在被拒绝后以各种理由取消对方的试镜资格。',
      '值得注意的是，D导剧组的多位工作人员也匿名向媒体透露，导演在片场经常对女演员动手动脚，且经常将"私约"安排在拍摄结束后。不少工作人员因担心丢掉工作而选择沉默。',
      '面对汹涌的舆论，D导通过律师发布声明，否认所有指控，称"这是有组织的恶意诽谤，将追究法律责任"。然而，目前已有超过10位女性站出来指证，且有多个实锤证据流出，D导的否认显得苍白无力。',
      '行业协会已对此事表示关注，称将展开调查。多家与D导有合作意向的制片方也紧急暂停了项目谈判。这场风波的最终走向，仍有待进一步观察。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Private%20club%20interior%20with%20dim%20lighting%2C%20empty%20leather%20sofas%2C%20mysterious%20and%20luxurious%20atmosphere%2C%20warm%20amber%20lighting%2C%20investigative%20scene&width=800&height=533&seq=card-4-rel-01&orientation=landscape',
        caption: 'D导被指控约见女演员的私人会所'
      }
    ],
    comments: [
      { id: 'cmt-c4-1', userName: '女权战士', userAvatar: makeAvatar('c4-ava-01'), content: '终于有人站出来了！这种导演就该被行业封杀，不能让更多人受害。', likes: 12345, publishDate: '2026-07-01' },
      { id: 'cmt-c4-2', userName: '业内人士', userAvatar: makeAvatar('c4-ava-02'), content: '这种事在圈内早就不是秘密了，只是很多人不敢说话。给勇敢站出来的女孩们点赞。', likes: 9876, publishDate: '2026-07-01' }
    ],
    hotScore: 62109
  },

  'card-5': {
    id: 'card-5',
    title: '当红小生学历造假，粉丝脱粉回踩曝猛料',
    subtitle: '名校光环被母校否认，合作品牌纷纷解约',
    category: '网红黑料',
    categorySlug: 'influencer-drama',
    author: '教育打假人',
    publishDate: '2026-06-30',
    readTime: '5分钟',
    viewCount: 432109,
    mainImage: 'https://readdy.ai/api/search-image?query=University%20campus%20with%20modern%20architecture%20at%20sunset%2C%20graduation%20cap%20on%20a%20bench%2C%20dramatic%20golden%20light%2C%20symbolic%20composition%2C%20warm%20atmospheric%20tones%2C%20cinematic%20photography&width=1200&height=675&seq=card-5-main&orientation=landscape',
    tags: ['学历造假', '人设崩塌', '粉丝脱粉'],
    content: [
      '某当红小生（以下简称X生）近日陷入学历造假风波。其在多档综艺节目中自称毕业于某顶尖艺术院校表演系，且成绩优异。然而，该校校友会近日公开发声否认了这一说法，引发轩然大波。',
      'X生近年来凭借几部热播剧迅速走红，其"学霸+实力派"的人设深受粉丝喜爱。在其个人简介和多次采访中，他都强调自己的名校背景，并表示"扎实的学院派训练是自己演技的基础"。',
      '事情的导火索是一位自称同届校友的网友在社交平台发文，称在学校的毕业生名录中查不到X生的名字。该帖文迅速引发关注，随后更多校友加入讨论，均表示从未听说过此人。',
      '面对质疑，X生的团队最初选择沉默。三天后，团队发布声明称"因个人隐私原因，不方便公开详细学籍信息"，并暗示将追究造谣者的法律责任。然而，这份模棱两可的声明不仅未能平息质疑，反而引发了更大规模的嘲讽。',
      '更让X生雪上加霜的是，其多位大粉（粉丝头目）相继宣布脱粉，并回踩曝出了更多猛料。有粉丝称X生连最基本的台词功底都不过关，经常需要后期配音；还有粉丝爆料其在片场态度傲慢，对工作人员呼来喝去。',
      '截至目前，已有三个与X生有代言合作的品牌宣布解约。其主演的待播剧也被传可能面临延期或换角。这场学历造假风波，恐怕将成为X生演艺生涯的转折点。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=University%20graduation%20ceremony%20with%20blurred%20faces%2C%20diploma%20scrolls%2C%20academic%20setting%2C%20warm%20golden%20lighting%2C%20education%20concept&width=800&height=533&seq=card-5-rel-01&orientation=landscape',
        caption: 'X生自称毕业的顶尖艺术院校'
      }
    ],
    comments: [
      { id: 'cmt-c5-1', userName: '前粉丝', userAvatar: makeAvatar('c5-ava-01'), content: '脱粉了，真的恶心。学历造假是最不能容忍的，还天天拿学霸人设营销。', likes: 8765, publishDate: '2026-06-30' },
      { id: 'cmt-c5-2', userName: '路人', userAvatar: makeAvatar('c5-ava-02'), content: '演技这么差居然还能红，内娱真的完了。学历造假还能有那么多资源，背后金主是谁？', likes: 6543, publishDate: '2026-06-30' }
    ],
    hotScore: 58734
  },

  'grid-1': {
    id: 'grid-1',
    title: '聊天记录泄露门：某男星暧昧聊天全曝光',
    subtitle: '微信对话尺度惊人，时间跨度长达两年',
    category: '聊天记录',
    categorySlug: 'chat-leaks',
    author: '数码侦探',
    publishDate: '2026-07-05',
    readTime: '6分钟',
    viewCount: 1123456,
    mainImage: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20intimate%20chat%20messages%20with%20warm%20pink%20background%2C%20romantic%20texting%20atmosphere%2C%20soft%20lighting%2C%20close%20up%20shot%2C%20modern%20digital%20communication%20concept&width=1200&height=675&seq=grid-1-main&orientation=landscape',
    tags: ['聊天记录', '暧昧曝光', '男星黑料'],
    content: [
      '某已婚男星（以下简称W哥）近日遭遇毁灭性打击。其与前女助理的暧昧聊天记录被泄露至网络，内容尺度之大、时间跨度之长，令吃瓜群众目瞪口呆。',
      '泄露的聊天记录显示，两人的暧昧关系始于两年前。当时该女助理刚入职W哥的工作室，负责日常行程安排。从最初的"谢谢哥关心"到后来的"想你了，什么时候能见面"，聊天内容逐步升级。',
      '最劲爆的是一段发生在今年情人节的对话。W哥在对话中直言"我老婆出差了，今晚来我家"，并发送了自己家的定位。而女助理的回复更是大胆，称"终于不用偷偷摸摸了"。',
      '更让人震惊的是，W哥在聊天中多次贬低自己的妻子，称其"人老珠黄，根本不懂我"。这些言论一经曝光，立即引发了网友的强烈谴责。不少粉丝表示"人设崩塌，彻底脱粉"。',
      '据悉，聊天记录的泄露者是该女助理的闺蜜。闺蜜称，女助理曾多次向她倾诉与W哥的关系，并给她看过这些聊天记录。后来两人因经济纠纷反目，闺蜜一气之下将记录公之于众。',
      'W哥的妻子目前尚未就此事公开发声，但其社交媒体已停止更新，并关闭了评论功能。据知情人透露，女方正在咨询离婚律师，准备启动离婚程序。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20phone%20screen%20showing%20deleted%20chat%20recovery%2C%20digital%20forensics%20concept%2C%20warm%20screen%20glow%2C%20technology%20investigation&width=800&height=533&seq=grid-1-rel-01&orientation=landscape',
        caption: '泄露的部分聊天记录截图'
      }
    ],
    comments: [
      { id: 'cmt-g1-1', userName: '震惊全家', userAvatar: makeAvatar('g1-ava-01'), content: '这也太恶心了吧，已婚男人还这么搞，还骂自己老婆？渣到家了。', likes: 15678, publishDate: '2026-07-05' },
      { id: 'cmt-g1-2', userName: '婚姻保卫战', userAvatar: makeAvatar('g1-ava-02'), content: '女方赶紧离婚吧，这种男人留着过年？证据这么充分，财产分割肯定占优势。', likes: 12345, publishDate: '2026-07-05' }
    ],
    hotScore: 92345
  },

  'grid-2': {
    id: 'grid-2',
    title: '经纪人深夜密谈：疑似为艺人安排潜规则',
    subtitle: '餐厅偶遇目击者拍下关键画面',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    author: '夜行侠',
    publishDate: '2026-07-03',
    readTime: '5分钟',
    viewCount: 987654,
    mainImage: 'https://readdy.ai/api/search-image?query=Two%20people%20having%20a%20secret%20conversation%20in%20a%20dimly%20lit%20restaurant%20corner%2C%20mysterious%20atmosphere%2C%20spy%20movie%20style%2C%20warm%20ambient%20lighting%2C%20shadows%20and%20intrigue&width=1200&height=675&seq=grid-2-main&orientation=landscape',
    tags: ['潜规则', '经纪人黑料', '行业内幕'],
    content: [
      '某知名艺人经纪人（以下简称Q姐）近日被目击深夜与一位制片人密会。目击者称，两人在高级日料店的包厢内交谈近两小时，期间Q姐多次展示出手机上的艺人照片，疑似在"推荐资源"。',
      '据目击者描述，当晚约11点左右，Q姐独自进入一家位于商圈顶层的日料店。大约20分钟后，一位中年男子也进入店内，径直走向Q姐所在的包厢。两人的交谈持续了将近两个小时，期间服务员被明确告知"不要打扰"。',
      '更令人生疑的是，Q姐在谈话过程中多次拿出手机，向对面男子展示某年轻女艺人的照片和视频。目击者称，Q姐的表情和肢体语言"看起来不像是正常的商务洽谈，更像是在推销商品"。',
      '事后，有网友通过对比餐厅外墙监控中男子的身形和走路姿态，推测该男子是某大型影视项目的制片人L某。L某在业内以"善于发掘新人"著称，但近年来也多次被传出与新人演员存在不当关系的传闻。',
      'Q姐所在的经纪公司对此事回应称"是正常的项目合作洽谈"，并警告网友"不要捕风捉影"。然而，这番回应并未平息质疑。有前员工爆料称，Q姐曾多次以"资源交换"为由，安排旗下新人参加各种"应酬"。',
      '目前，被涉及的年轻女艺人已暂停了所有社交活动，其粉丝后援会也宣布暂时休站。这场风波的后续发展，值得持续关注。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=High%20end%20Japanese%20restaurant%20exterior%20at%20night%2C%20discreet%20entrance%2C%20warm%20lantern%20lighting%2C%20mysterious%20atmosphere%2C%20urban%20nightlife&width=800&height=533&seq=grid-2-rel-01&orientation=landscape',
        caption: 'Q姐与制片人密会的日料店'
      }
    ],
    comments: [
      { id: 'cmt-g2-1', userName: '圈内老油条', userAvatar: makeAvatar('g2-ava-01'), content: '这种操作在圈里太常见了，艺人就是商品，经纪人就是销售，制片人就是买家。', likes: 8765, publishDate: '2026-07-03' },
      { id: 'cmt-g2-2', userName: '新人演员', userAvatar: makeAvatar('g2-ava-02'), content: '作为刚入行的新人，看了这种新闻真的心寒。但有时候不答应就没资源，太难了。', likes: 6543, publishDate: '2026-07-03' }
    ],
    hotScore: 81234
  },

  'grid-3': {
    id: 'grid-3',
    title: '女团成员内部霸凌：退团成员含泪揭露真相',
    subtitle: '长达三年的霸凌史，公司选择沉默',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    author: '韩娱搬运工',
    publishDate: '2026-07-01',
    readTime: '7分钟',
    viewCount: 876543,
    mainImage: 'https://readdy.ai/api/search-image?query=Kpop%20style%20dance%20practice%20room%20with%20mirrors%2C%20empty%20and%20lonely%20atmosphere%2C%20soft%20gray%20lighting%2C%20dramatic%20shadows%2C%20emotional%20and%20melancholic%20mood%2C%20warm%20gray%20tones&width=1200&height=675&seq=grid-3-main&orientation=landscape',
    tags: ['女团霸凌', '退团内幕', '职场霸凌'],
    content: [
      '某人气女团前成员小T近日在直播中痛哭流涕，揭露了其在团期间长达三年的霸凌经历。她指控团队中的C位成员小S长期对她进行言语羞辱、社交孤立甚至肢体推搡，而公司对此始终选择沉默。',
      '小T在直播中表示，霸凌从她入团的第一年就开始了。当时小S作为团队中的"大姐大"，经常在练习室里当众批评她的舞蹈动作，用词极其难听。"她不止一次说我这种水平根本不该出道，拖了整个团队的后腿。"',
      '更过分的是，小S还联合另外两名成员对小T进行社交孤立。宿舍生活中，三人经常一起外出聚餐却从不叫上小T；在团队群聊中，她们会故意用只有彼此才懂的暗语交流，让小T感觉自己是个局外人。',
      '小T还展示了一段手机录音，录音中可以清楚地听到练习室里传来争吵声。一个尖锐的女声（疑似小S）在怒吼"你敢再说一遍试试？"，随后是一声闷响和物品摔落的声音。小T解释，当时小S因为不满她的站位，直接将她推倒在地。',
      '面对小T的指控，小S在个人社交账号上发布了一张全员合照，配文"永远的姐妹"，疑似在否认霸凌传闻。然而，细心的网友发现，这张合照中所有人都在笑，唯独小T的表情十分勉强。',
      '女团所属经纪公司发表声明，称"正在内部调查中"，但并未承诺采取任何具体措施。小T的粉丝已发起联署，要求公司对霸凌事件给出明确交代，并为小T在团期间遭受的不公待遇道歉。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Group%20photo%20of%20young%20women%20in%20matching%20outfits%2C%20one%20person%20with%20forced%20smile%20while%20others%20laugh%20naturally%2C%20subtle%20tension%2C%20warm%20stage%20lighting&width=800&height=533&seq=grid-3-rel-01&orientation=landscape',
        caption: '小S发布的"永远的姐妹"合照，小T表情勉强'
      }
    ],
    comments: [
      { id: 'cmt-g3-1', userName: '前练习生', userAvatar: makeAvatar('g3-ava-01'), content: '太懂了，练习室里这种霸凌真的很常见，大公司会压下来，小艺人只能忍气吞声。', likes: 9876, publishDate: '2026-07-01' },
      { id: 'cmt-g3-2', userName: 'T的粉丝', userAvatar: makeAvatar('g3-ava-02'), content: '看了直播真的心疼哭了，小T在团三年受了这么多委屈，公司必须给个说法！', likes: 8765, publishDate: '2026-07-01' }
    ],
    hotScore: 76543
  },

  'grid-4': {
    id: 'grid-4',
    title: '豪门婚礼变闹剧：新郎前女友大闹现场',
    subtitle: '婚礼现场曝光视频刷屏全网',
    category: '豪门恩怨',
    categorySlug: 'rich-drama',
    author: '婚礼摄影师',
    publishDate: '2026-06-29',
    readTime: '5分钟',
    viewCount: 765432,
    mainImage: 'https://readdy.ai/api/search-image?query=Luxury%20wedding%20venue%20in%20chaos%2C%20overturned%20tables%20and%20chairs%2C%20dramatic%20atmosphere%2C%20warm%20golden%20chandelier%20lighting%2C%20wedding%20decorations%20scattered%2C%20cinematic%20composition%20with%20warm%20amber%20and%20brown%20tones&width=1200&height=675&seq=grid-4-main&orientation=landscape',
    tags: ['婚礼闹剧', '前女友', '豪门婚礼'],
    content: [
      '某富二代与名媛的世纪婚礼近日变成全网笑柄。婚礼仪式进行到交换戒指环节时，新郎的前女友突然闯入现场，手持扩音器大喊"他骗了你，他根本不想结婚"，场面一度失控。',
      '据现场宾客拍摄的视频显示，前女友（以下简称小V）身着一袭黑裙，在众目睽睽之下从婚礼大厅的后门闯入。她一边大步走向舞台，一边用扩音器播放一段录音。录音中，新郎的声音清晰可辨："等我把她家那笔投资拿到手就分手，这婚结了也是白结。"',
      '新娘当场愣在原地，手中的花束滑落在地。她的伴娘团迅速冲上前试图阻止小V，但小V早有准备，一边后退一边继续播放更多录音片段。其中一段录音中，新郎向小V承诺"结婚后我们还可以继续见面，她又不知道"。',
      '新郎的父母坐在台下第一排，脸色铁青。据知情人士透露，这场婚礼的筹备费用高达数百万元，邀请的宾客包括多位商界名流。婚礼闹剧发生后，新郎父亲当场离席，多名商界宾客也提前退场。',
      '更戏剧性的是，新娘的家族随后宣布取消原定的新婚投资计划。据悉，双方家族原本计划通过这桩联姻整合各自的商业版图，婚礼闹剧直接导致合作泡汤。',
      '截至目前，新郎的社交账号已设置为私密，而新娘则清空了所有与婚礼相关的内容。这场豪门婚礼闹剧，恐怕将成为本年度最劲爆的瓜之一。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Wedding%20ceremony%20stage%20with%20scattered%20flower%20petals%2C%20empty%20aisle%2C%20dramatic%20warm%20lighting%2C%20interrupted%20celebration%2C%20luxury%20venue&width=800&height=533&seq=grid-4-rel-01&orientation=landscape',
        caption: '婚礼闹剧后的现场一片狼藉'
      }
    ],
    comments: [
      { id: 'cmt-g4-1', userName: '婚礼策划师', userAvatar: makeAvatar('g4-ava-01'), content: '做了十年婚礼策划，第一次见这么猛的前女友。这新娘太惨了，但也算是及时止损。', likes: 12345, publishDate: '2026-06-29' },
      { id: 'cmt-g4-2', userName: '吃瓜网友', userAvatar: makeAvatar('g4-ava-02'), content: '这剧情比电视剧还精彩，豪门联姻果然都是利益交换。新娘赶紧离婚止损吧！', likes: 9876, publishDate: '2026-06-29' }
    ],
    hotScore: 89123
  },

  'star-1': {
    id: 'star-1',
    title: '某影帝深夜约会神秘女，两人牵手散步被拍',
    subtitle: '影帝新恋情疑似曝光',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    author: '狗仔队长',
    publishDate: '2026-07-06',
    readTime: '4分钟',
    viewCount: 654321,
    mainImage: 'https://readdy.ai/api/search-image?query=Couple%20walking%20hand%20in%20hand%20on%20a%20romantic%20night%20street%2C%20warm%20street%20lamps%2C%20blurry%20background%2C%20paparazzi%20style%20photography%2C%20cinematic%20night%20scene%20with%20warm%20golden%20tones&width=1200&height=675&seq=star-1-main&orientation=landscape',
    tags: ['影帝恋情', '街头约会', '深夜被拍'],
    content: [
      '三金影帝L某近日被拍到与一位神秘女子深夜牵手散步。两人举止亲密，毫无避讳，疑似新恋情曝光。',
      '据狗仔爆料，当晚约凌晨1点，L某与神秘女子出现在某高档住宅区附近的步道上。两人身着休闲装，手牵着手漫步，还不时停下来对视微笑。L某甚至脱下外套披在女方肩上，举动十分体贴。',
      '神秘女子的身份目前尚不清楚。但从照片来看，她身材高挑，气质出众，年龄大约在25岁左右。有网友猜测可能是圈内新人演员，也有人认为是L某的大学同学。',
      'L某此前曾有过一段轰动一时的婚姻，但于两年前和平分手。离婚后的他一直保持单身形象，此次深夜约会若属实，将是他离婚后的首次恋情曝光。',
      '截至目前，L某工作室尚未就此事作出回应。而L某的粉丝们则纷纷表示祝福，称"影帝也是人，有权追求自己的幸福"。'
    ],
    relatedImages: [],
    comments: [
      { id: 'cmt-s1-1', userName: '影迷小王', userAvatar: makeAvatar('s1-ava-01'), content: '祝福影帝！离婚两年了谈个恋爱很正常，女方看起来气质不错。', likes: 7654, publishDate: '2026-07-06' },
      { id: 'cmt-s1-2', userName: '八卦小灵通', userAvatar: makeAvatar('s1-ava-02'), content: '据我打听，女方是某艺术学院的学生，比影帝小15岁。等着看后续吧。', likes: 5432, publishDate: '2026-07-06' }
    ],
    hotScore: 92134
  },

  'inf-1': {
    id: 'inf-1',
    title: '美妆博主带货翻车，粉丝使用产品后烂脸',
    subtitle: '三无产品害人不浅，品牌方紧急撇清关系',
    category: '网红黑料',
    categorySlug: 'influencer-drama',
    author: '美妆打假号',
    publishDate: '2026-07-04',
    readTime: '6分钟',
    viewCount: 789012,
    mainImage: 'https://readdy.ai/api/search-image?query=Makeup%20products%20scattered%20on%20a%20vanity%20table%2C%20broken%20compact%20powder%2C%20dramatic%20lighting%2C%20beauty%20disaster%20concept%2C%20warm%20rose%20and%20pink%20tones&width=1200&height=675&seq=inf-1-main&orientation=landscape',
    tags: ['带货翻车', '三无产品', '消费者受害'],
    content: [
      '百万粉丝美妆博主K姐近日推荐的某款"神奇面霜"被证实为三无产品，多名粉丝使用后出现严重皮肤过敏反应，甚至有人面部红肿溃烂。',
      'K姐在上周的直播中大力推荐这款面霜，宣称其"含有珍稀植物提取物，7天就能让肌肤焕然一新"。在直播期间，她还展示了所谓的产品检测报告和使用前后对比图，说服力极强。',
      '然而，产品上架不到一周，问题就开始爆发。粉丝小A在使用第三天后面部出现大面积红肿，就医后被诊断为接触性皮炎。更可怕的是，小A并非个例——维权群里已有超过50人报告了类似症状。',
      '有化学专业背景的网友对这款面霜进行了成分分析，发现其中根本不含K姐宣传的任何"珍稀植物提取物"，反而含有高浓度的激素类物质和工业防腐剂。这些物质短期内可能让皮肤看起来光滑，但长期使用会造成不可逆的激素依赖性皮炎。',
      '面对粉丝们的维权，K姐最初在评论区回应称"个体差异导致过敏，不属于产品质量问题"。但在越来越多的实锤证据面前，她最终删除了相关直播回放，并悄悄下架了店铺链接。',
      '目前，受害粉丝们已组建维权群，准备集体向市场监督管理部门投诉，并保留起诉K姐的权利。而K姐的账号粉丝数也在持续下跌，短短三天已掉粉超过20万。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Severe%20skin%20allergic%20reaction%20on%20face%2C%20dermatological%20condition%2C%20medical%20photography%2C%20warm%20clinical%20lighting%2C%20sensitive%20content%20warning&width=800&height=533&seq=inf-1-rel-01&orientation=landscape',
        caption: '受害者小A使用后面部红肿溃烂'
      }
    ],
    comments: [
      { id: 'cmt-i1-1', userName: '受害者A', userAvatar: makeAvatar('i1-ava-01'), content: '我就是用了她推荐的面霜烂脸的！正在准备材料起诉她，大家一起维权！', likes: 9876, publishDate: '2026-07-04' },
      { id: 'cmt-i1-2', userName: '护肤博主', userAvatar: makeAvatar('i1-ava-02'), content: '作为同行真的愤怒，这种博主为了钱什么产品都推，完全不顾粉丝死活。', likes: 7654, publishDate: '2026-07-04' }
    ],
    hotScore: 89123
  },

  'chat-1': {
    id: 'chat-1',
    title: '某男星暧昧聊天记录曝光：与多名女粉丝私信调情',
    subtitle: '时间跨度三年，受害者超过十人',
    category: '聊天记录',
    categorySlug: 'chat-leaks',
    author: '网络侦探',
    publishDate: '2026-07-05',
    readTime: '7分钟',
    viewCount: 1234567,
    mainImage: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20flirty%20text%20messages%2C%20intimate%20atmosphere%2C%20warm%20screen%20glow%20in%20darkness%2C%20privacy%20invasion%20concept%2C%20multiple%20chat%20bubbles&width=1200&height=675&seq=chat-1-main&orientation=landscape',
    tags: ['暧昧私信', '粉丝诱骗', '男星翻车'],
    content: [
      '某二线男星（以下简称F哥）近日被多名女粉丝联合曝光暧昧私信记录。这些记录显示，F哥长期利用明星身份与粉丝进行不当交流，时间跨度长达三年，受害者超过十人。',
      '首位站出来曝光的是粉丝小H。她向媒体提供了长达半年的私信记录，其中F哥多次向她发送露骨信息，并以"有机会见面详聊"为诱饵，要求她发送私密照片。',
      '更令人震惊的是，F哥似乎有一套固定的"话术模板"。他对不同粉丝使用的开场白几乎一模一样："谢谢你的支持，你是我见过最有品味的粉丝"、"你长得很像我前女友"、"有机会请你吃饭"等等。',
      '在多名受害者晒出的记录中，F哥的套路高度一致：先用甜言蜜语拉近距离，再以"想要更深入地了解你"为由索要照片，最后以"最近太忙，改天再约"为由逐渐冷淡。当粉丝试图追问时，他便会直接拉黑对方。',
      '受害者们的联合发声引发了强烈反响。有网友统计，按照目前的曝光量，F哥的受害者可能远不止十人。更令人愤怒的是，F哥在公开场合一直以"宠粉暖男"形象示人，不少粉丝正是被这种反差人设所吸引。',
      'F哥的经纪公司发表声明称"将对造谣者追究法律责任"，但并未正面回应任何具体指控。而粉丝们则迅速分裂为两派——一派坚决维护偶像，称"聊天记录可以P图"；另一派则要求F哥给出合理解释，否则将集体脱粉。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Collage%20of%20multiple%20phone%20screens%20showing%20similar%20chat%20conversations%2C%20pattern%20of%20manipulation%2C%20warm%20digital%20glow%2C%20social%20media%20investigation&width=800&height=533&seq=chat-1-rel-01&orientation=landscape',
        caption: '多名受害者晒出的相似聊天记录'
      }
    ],
    comments: [
      { id: 'cmt-ch1-1', userName: '受害者联盟', userAvatar: makeAvatar('ch1-ava-01'), content: '我们都是受害者！他把我们当傻子耍，话术都不带换的，太恶心了！', likes: 15678, publishDate: '2026-07-05' },
      { id: 'cmt-ch1-2', userName: '心理学硕士', userAvatar: makeAvatar('ch1-ava-02'), content: '典型的权力不对等下的情感操控，利用明星光环对粉丝进行精神控制。这种人应该被封杀。', likes: 12345, publishDate: '2026-07-05' }
    ],
    hotScore: 93145
  },

  'contest-1': {
    id: 'contest-1',
    title: '今日最劲爆：某顶流被拍到夜店亲密，与三女同行至凌晨四点',
    subtitle: '顶流塌房现场直击',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    author: '夜店目击者',
    publishDate: '2026-07-07',
    readTime: '4分钟',
    viewCount: 1567890,
    mainImage: 'https://readdy.ai/api/search-image?query=Nightclub%20exterior%20at%20night%20with%20neon%20lights%2C%20people%20partying%2C%20dramatic%20nightlife%20atmosphere%2C%20warm%20red%20and%20golden%20neon%20glow%2C%20VIP%20entrance%20with%20velvet%20ropes&width=1200&height=675&seq=contest-1-main&orientation=landscape',
    tags: ['夜店风流', '顶流塌房', '今日冠军'],
    content: [
      '今日吃瓜大赛冠军非某顶流男艺人莫属。该艺人被拍到深夜现身某高端夜店，与三名女子亲密互动直至凌晨四点，完全不顾自己此前立下的"乖宝宝"人设。',
      '据夜店内部人员透露，该艺人当晚包下了VIP卡座，消费金额超过十万元。他先与一名金发女子贴身热舞，随后又在卡座内与另外两名女子玩骰子饮酒游戏，举止十分亲密。',
      '更令人大跌眼镜的是，该艺人在酒醉后竟然当众发表了不当言论，称"粉丝就是用来赚钱的，谁管她们怎么想"。这番话被邻桌的客人录下并上传网络，引发了粉丝的集体崩溃。',
      '凌晨四点离开时，该艺人已醉得不省人事，由助理和两名女子搀扶着从后门离开。他在酒店门口还试图与一名路人发生冲突，最终被助理强行塞入车内带走。',
      '截至发稿，该艺人的多个粉丝站已宣布关闭，超话排名暴跌。其代言的品牌方也开始紧急撤下相关宣传物料。这场塌房来得又快又狠，堪称本年度最佳吃瓜现场。'
    ],
    relatedImages: [],
    comments: [
      { id: 'cmt-co1-1', userName: '心碎粉丝', userAvatar: makeAvatar('co1-ava-01'), content: '六年老粉，今天正式脱粉。他说粉丝就是用来赚钱的时候，我心彻底死了。', likes: 23456, publishDate: '2026-07-07' },
      { id: 'cmt-co1-2', userName: '吃瓜冠军', userAvatar: makeAvatar('co1-ava-02'), content: '今日大赛冠军实至名归！这瓜又大又甜，塌房速度创纪录了。', likes: 19876, publishDate: '2026-07-07' }
    ],
    hotScore: 98765
  },

  'show-1': {
    id: 'show-1',
    title: '某选秀节目投票造假，内部人员爆料暗箱操作',
    subtitle: '人气选手票数被恶意削减',
    category: '综艺翻车',
    categorySlug: 'show-fails',
    author: '综艺内部人',
    publishDate: '2026-07-04',
    readTime: '6分钟',
    viewCount: 876543,
    mainImage: 'https://readdy.ai/api/search-image?query=Voting%20machines%20and%20screens%20in%20a%20dark%20room%2C%20election%20fraud%20concept%2C%20dramatic%20lighting%2C%20reality%20show%20scandal%2C%20warm%20red%20warning%20lights&width=1200&height=675&seq=show-1-main&orientation=landscape',
    tags: ['投票造假', '选秀黑幕', '暗箱操作'],
    content: [
      '某热门选秀节目的投票环节近日被内部人员爆料存在造假行为。据爆料者称，节目组为了控制出道人选，通过技术手段恶意削减特定选手的票数，同时给内定选手注水。',
      '爆料者自称是节目技术团队的一员。他透露，每次公演后的投票数据都会先经过"处理"再对外公布。处理的方式包括：将某些选手的真实票数按百分比削减、给特定选手添加"虚拟票"、以及将分散投票合并到目标选手名下。',
      '最受影响的是选手小C。根据粉丝自发组织的打投数据，小C的真实票数应该排在出道位以内，但最终公布的结果却显示她排名第十一，无缘出道。粉丝们整理的多平台数据与官方票数存在超过20%的差距。',
      '爆料者还提供了一段内部会议录音。录音中，节目制片人明确表示"不能让XXX出道，她的经纪公司跟我们有过节"。这段录音一经曝光，立即引发了选手粉丝的大规模抗议。',
      '目前，已有超过5万名观众向广电总局递交了投诉信，要求彻查该节目的投票数据真实性。而节目组的官方回应则坚称"投票公平公正，接受监督"，但并未公布任何原始数据。',
      '业内专家指出，选秀节目的投票造假在业内早已不是秘密，但如此大规模的实名爆料仍属罕见。这场风波可能会引发监管部门对整个选秀行业的整顿。'
    ],
    relatedImages: [
      {
        url: 'https://readdy.ai/api/search-image?query=Data%20center%20server%20room%20with%20screens%20showing%20manipulated%20numbers%2C%20digital%20fraud%20concept%2C%20warm%20blue%20and%20red%20lighting%2C%20technology%20corruption&width=800&height=533&seq=show-1-rel-01&orientation=landscape',
        caption: '被指控存在数据造假的技术后台'
      }
    ],
    comments: [
      { id: 'cmt-sw1-1', userName: '小C的粉丝', userAvatar: makeAvatar('sw1-ava-01'), content: '我们打了三个月的投，花了十几万，结果告诉我们票被黑了？节目组还我们一个公道！', likes: 12345, publishDate: '2026-07-04' },
      { id: 'cmt-sw1-2', userName: '综艺研究者', userAvatar: makeAvatar('sw1-ava-02'), content: '选秀投票造假早就该查了，每次都是粉丝真金白银投的票，结果被节目当猴耍。', likes: 9876, publishDate: '2026-07-04' }
    ],
    hotScore: 87654
  },

  'rich-1': {
    id: 'rich-1',
    title: '某地产大亨婚变：原配与小三大打出手',
    subtitle: '豪宅内爆发肢体冲突，警方介入调查',
    category: '豪门恩怨',
    categorySlug: 'rich-drama',
    author: '豪宅邻居',
    publishDate: '2026-07-03',
    readTime: '5分钟',
    viewCount: 987654,
    mainImage: 'https://readdy.ai/api/search-image?query=Luxury%20living%20room%20in%20chaos%20after%20fight%2C%20broken%20vase%20and%20furniture%2C%20dramatic%20lighting%2C%20domestic%20conflict%20in%20wealthy%20household%2C%20warm%20golden%20lighting%2C%20shattered%20glass&width=1200&height=675&seq=rich-1-main&orientation=landscape',
    tags: ['婚变', '原配打小三', '豪门内幕'],
    content: [
      '某地产大亨的亿万豪宅近日上演了一场"正宫斗小三"的真人秀。原配妻子在发现丈夫将情妇带入家中后，亲自上门对峙，双方在豪宅内爆发激烈肢体冲突，最终惊动警方介入。',
      '据豪宅区的保安透露，当天下午约3点，一辆黑色豪车驶入小区，车上下来一位中年女子（即原配），身后还跟着两名身材魁梧的男子（疑似保镖）。原配直接刷卡进入了丈夫名下的独栋别墅。',
      '大约半小时后，别墅内传出激烈的争吵声和物品摔碎的声音。邻居称听到女子尖叫"你这个狐狸精敢进我家"，随后是一连串的碰撞声。有邻居报警称"可能发生家暴"。',
      '警方到达现场时，屋内一片狼藉。价值数十万元的古董花瓶被砸碎，真皮沙发上满是红酒渍。原配和情妇均有不同程度的抓伤，地产大亨本人则躲在书房里不敢露面。',
      '更令人震惊的是，原配在现场向警方出示了一份文件，显示该豪宅虽登记在丈夫名下，但购房款全部来自她的家族资产。她当场要求情妇"立刻滚出去，否则以非法侵入住宅罪起诉"。',
      '截至目前，地产大亨尚未就此事作出任何公开回应。其旗下的地产公司股价已连续三天下跌，市值蒸发超过5亿元。这场豪门闹剧，恐怕还远未结束。'
    ],
    relatedImages: [],
    comments: [
      { id: 'cmt-r1-1', userName: '邻居阿姨', userAvatar: makeAvatar('r1-ava-01'), content: '我就在隔壁，听得清清楚楚。原配太霸气了，带着保镖直接闯进去，小三吓得直哭。', likes: 15678, publishDate: '2026-07-03' },
      { id: 'cmt-r1-2', userName: '婚姻咨询师', userAvatar: makeAvatar('r1-ava-02'), content: '虽然小三可恨，但原配这种处理方式也有法律风险。建议还是走法律途径更稳妥。', likes: 8765, publishDate: '2026-07-03' }
    ],
    hotScore: 91234
  }
};

export const allArticleIds = Object.keys(articleData);